export enum PDFFormType {
	ON_GST_190_CALCULATION_WS = 'ON_GST_190_CALCULATION_WS',
	ON_GST_190_REBATE_SCHEDULE = 'ON_GST_190_REBATE_SCHEDULE',
	ON_GST_NEW_HOUSING_REBATE = 'ON_GST_NEW_HOUSING_REBATE',
	ON_GST_524_REBATE_SCHEDULE = 'ON_GST_524_REBATE_SCHEDULE',
	ON_GST_NEW_REBATE_RENTAL = 'ON_GST_NEW_REBATE_RENTAL',
	ON_GST_190_APPENDIX_A = 'ON_GST_190_APPENDIX_A',

	RBC_COLLATERAL_FINAL_REPORT = 'RBC_COLLATERAL_FINAL_REPORT',
	RBC_COLLATERAL_REQUEST_FOR_FUNDS = 'RBC_COLLATERAL_REQUEST_FOR_FUNDS',
	RBC_COLLATERAL_SCHEDULE_PRIME_RATE = 'RBC_COLLATERAL_SCHEDULE_PRIME_RATE',
	RBC_COLLATERAL_SCHEDULE_FIXED_RATE = 'RBC_COLLATERAL_SCHEDULE_FIXED_RATE',
	RBC_COLLATERAL_STANDARD_CHARGE_TERMS = 'RBC_COLLATERAL_STANDARD_CHARGE_TERMS',

	RBC_RESIDENTIAL_ASSIGNMENT_OF_SITE_LEASE = 'RBC_RESIDENTIAL_ASSIGNMENT_OF_SITE_LEASE',
	RBC_RESIDENTIAL_FINAL_REPORT = 'RBC_RESIDENTIAL_FINAL_REPORT',
	RBC_RESIDENTIAL_LANDLORD_CONSENT = 'RBC_RESIDENTIAL_LANDLORD_CONSENT',
	RBC_RESIDENTIAL_LETTER_FOR_ILA = 'RBC_RESIDENTIAL_LETTER_FOR_ILA',
	RBC_RESIDENTIAL_LETTER_OF_DIRECTION = 'RBC_RESIDENTIAL_LETTER_OF_DIRECTION',
	RBC_RESIDENTIAL_REQUEST_FOR_FUNDS = 'RBC_RESIDENTIAL_REQUEST_FOR_FUNDS',
	RBC_RESIDENTIAL_SECURITY_AGREEMENT = 'RBC_RESIDENTIAL_SECURITY_AGREEMENT',
	RBC_RESIDENTIAL_SCT_VARIABLE = 'RBC_RESIDENTIAL_SCT_VARIABLE',
	RBC_RESIDENTIAL_SCT_FIXED = 'RBC_RESIDENTIAL_SCT_FIXED',

	BMO_COLLATERAL_FINAL_REPORT = 'BMO_COLLATERAL_FINAL_REPORT',
	BMO_COLLATERAL_REQUEST_FOR_FUNDS = 'BMO_COLLATERAL_REQUEST_FOR_FUNDS',
	BMO_COLLATERAL_SCHEDULE = 'BMO_COLLATERAL_SCHEDULE',
	BMO_COLLATERAL_STANDARD_CHARGE_TERMS = 'BMO_COLLATERAL_STANDARD_CHARGE_TERMS',

	BMO_CONVENTIONAL_ACKNOWLEDGEMENT_AND_DIRECTION = 'BMO_CONVENTIONAL_ACKNOWLEDGEMENT_AND_DIRECTION',
	BMO_CONVENTIONAL_COVER_SHEET = 'BMO_CONVENTIONAL_COVER_SHEET',
	BMO_CONVENTIONAL_FINAL_REPORT = 'BMO_CONVENTIONAL_FINAL_REPORT',
	BMO_CONVENTIONAL_ID_VERIFICATION = 'BMO_CONVENTIONAL_ID_VERIFICATION',
	BMO_CONVENTIONAL_MTG_DECLARATION_OF_POSSESSION = 'BMO_CONVENTIONAL_MTG_DECLARATION_OF_POSSESSION',
	BMO_CONVENTIONAL_REQUEST_FOR_FUNDS = 'BMO_CONVENTIONAL_REQUEST_FOR_FUNDS',
	BMO_CONVENTIONAL_RESIDENTIAL_MORTGAGE_SCHEDULE = 'BMO_CONVENTIONAL_RESIDENTIAL_MORTGAGE_SCHEDULE',

	HOME_TRUST_ACKNOWLEDGEMENT_AND_DIRECTION_REFUNDS = 'HOME_TRUST_ACKNOWLEDGEMENT_AND_DIRECTION_REFUNDS',
	HOME_TRUST_AUTHORIZATION_DIRECTION_AND_CONSENT = 'HOME_TRUST_AUTHORIZATION_DIRECTION_AND_CONSENT',
	HOME_TRUST_FINAL_REPORT = 'HOME_TRUST_FINAL_REPORT',
	HOME_TRUST_PAYMENT_CHANGE_REQUEST_FORM = 'HOME_TRUST_PAYMENT_CHANGE_REQUEST_FORM',
	HOME_TRUST_PREAUTHORIZED_DEBIT_AGREEMENT = 'HOME_TRUST_PREAUTHORIZED_DEBIT_AGREEMENT',
	HOME_TRUST_REQUEST_FOR_FUNDS = 'HOME_TRUST_REQUEST_FOR_FUNDS',
	HOME_TRUST_SOLICITOR_DECLARATION_REIDENTIFICATION = 'HOME_TRUST_SOLICITOR_DECLARATION_REIDENTIFICATION',
	HOME_TRUST_STANDARD_CHARGE_TERMS = 'HOME_TRUST_STANDARD_CHARGE_TERMS',
	HOME_TRUST_STATUTORY_DECLARATION = 'HOME_TRUST_STATUTORY_DECLARATION',
	HOME_TRUST_TENANT_ACKNOWLEDGEMENT = 'HOME_TRUST_TENANT_ACKNOWLEDGEMENT',

	FIRST_NATIONAL_REQUEST_FOR_FUNDS = 'FIRST_NATIONAL_REQUEST_FOR_FUNDS',
	FIRST_NATIONAL_REPORT_ON_TITLE = 'FIRST_NATIONAL_REPORT_ON_TITLE',

	TD_REQUEST_FOR_FUNDS = 'TD_REQUEST_FOR_FUNDS',
	TD_FINAL_REPORT = 'TD_FINAL_REPORT',
	TD_FACE_TO_FACE_ID = 'TD_FACE_TO_FACE_ID',
	TD_PRIVACY_AGREEMENT = 'TD_PRIVACY_AGREEMENT',
	TD_NON_FACE_TO_FACE_ID = 'TD_NON_FACE_TO_FACE_ID',
	TD_SCHEDULE_1 = 'TD_SCHEDULE_1',

	CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_FINAL_REPORT = 'CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_FINAL_REPORT',
	CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS = 'CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS',
	CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_STANDARD_CHARGE_TERMS = 'CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_STANDARD_CHARGE_TERMS',
	CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_FINAL_REPORT = 'CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_FINAL_REPORT',
	CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_REQUEST_FOR_FUNDS = 'CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_REQUEST_FOR_FUNDS',

	CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_FINAL_REPORT = 'CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_FINAL_REPORT',
	CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_NOTIFICATION_OF_REGISTRATION = 'CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_NOTIFICATION_OF_REGISTRATION',
	CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS = 'CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS',
	CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_FINAL_REPORT = 'CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_FINAL_REPORT',
	CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS = 'CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS',
	CIBC_DOCUMENTS_HOME_POWER_PLAN_FINAL_REPORT = 'CIBC_DOCUMENTS_HOME_POWER_PLAN_FINAL_REPORT',
	CIBC_DOCUMENTS_HOME_POWER_PLAN_ID_VERIFICATION = 'CIBC_DOCUMENTS_HOME_POWER_PLAN_ID_VERIFICATION',
	CIBC_DOCUMENTS_HOME_POWER_PLAN_REQUEST_FOR_FUNDS = 'CIBC_DOCUMENTS_HOME_POWER_PLAN_REQUEST_FOR_FUNDS',
	CIBC_DOCUMENTS_HOME_POWER_PLAN_STANDARD_CHARGE_TERMS = 'CIBC_DOCUMENTS_HOME_POWER_PLAN_STANDARD_CHARGE_TERMS',
	CIBC_DOCUMENTS_MORTGAGE_FINAL_REPORT = 'CIBC_DOCUMENTS_MORTGAGE_FINAL_REPORT',
	CIBC_DOCUMENTS_MORTGAGE_ID_VERIFICATION = 'CIBC_DOCUMENTS_MORTGAGE_ID_VERIFICATION',
	CIBC_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS = 'CIBC_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS',
	CIBC_DOCUMENTS_MORTGAGE_STANDARD_CHARGE_TERMS = 'CIBC_DOCUMENTS_MORTGAGE_STANDARD_CHARGE_TERMS',
	CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_FINAL_REPORT = 'CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_FINAL_REPORT',
	CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_REQUEST_FOR_FUNDS = 'CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_REQUEST_FOR_FUNDS',

	STANDALONE_PURCHASE_PRESCRIBED_INFORMATION_FORM = 'STANDALONE_PURCHASE_PRESCRIBED_INFORMATION_FORM',

	LTT_AFFIDAVIT_FORM = 'LTT_AFFIDAVIT_FORM',
	LTT_REBATE_FORM = 'LTT_REBATE_FORM',
	MLTT_REBATE_FORM = 'MLTT_REBATE_FORM',
	MLTT_AFFIDAVIT_FORM = 'MLTT_AFFIDAVIT_FORM',
	MLTT_SUPPLEMENTARY_FORM = 'MLTT_SUPPLEMENTARY_FORM',

	FCT_UNDER_25 = 'FCT_UNDER_25',
	FCT_OVER_25 = 'FCT_OVER_25',
}

export interface MatterFormData {
	id: string;
	type: PDFFormType;
	name: string;
	values: {
		[key: string]: string;
	};
	url: string;
}

export enum PDFFormTypes {
	HST = 'hst',
	STANDALONE_PURCHASE = 'STANDALONE_PURCHASE',
	RBC_COLLATERAL = 'rbc_collateral',
	RBC_RESIDENTIAL = 'rbc_residential',
	BMO_COLLATERAL = 'bmo_collateral',
	BMO_CONVENTIONAL = 'bmo_conventional',
	HOME_TRUST = 'home_trust',
	FIRST_NATIONAL = 'first_national',
	TD = 'td',
	CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE = 'cibc_simplii_financial_documents_mortgage',
	CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT = 'cibc_simplii_financial_documents_secure_line_of_credit',
	CIBC_DOCUMENTS_COLLATERAL_MORTGAGE = 'cibc_documents_collateral_mortgage',
	CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE = 'cibc_documents_commercial_collateral_mortgage',
	CIBC_DOCUMENTS_HOME_POWER_PLAN = 'cibc_documents_home_power_plan',
	CIBC_DOCUMENTS_MORTGAGE = 'cibc_documents_mortgage',
	CIBC_DOCUMENTS_SPLC_FOR_PURCHASE = 'cibc_documents_splc_for_purchase',
	LTT = 'ltt',
	MLTT = 'mltt',
	FCT = 'fct',
}
export interface PDFForm {
	type: PDFFormTypes;
	form: PDFFormType;
	url: string;
	name: string;
}

export const PDFForms: { [id in PDFFormType]: PDFForm } = {
	[PDFFormType.ON_GST_524_REBATE_SCHEDULE]: {
		type: PDFFormTypes.HST,
		name: '',
		form: PDFFormType.ON_GST_524_REBATE_SCHEDULE,
		url: `2021/hst/${PDFFormType.ON_GST_524_REBATE_SCHEDULE.toLowerCase()}.pdf`,
	},
	[PDFFormType.ON_GST_190_APPENDIX_A]: {
		type: PDFFormTypes.HST,
		name: '',
		form: PDFFormType.ON_GST_190_APPENDIX_A,
		url: `2021/hst/${PDFFormType.ON_GST_190_APPENDIX_A.toLowerCase()}.pdf`,
	},
	[PDFFormType.ON_GST_190_CALCULATION_WS]: {
		type: PDFFormTypes.HST,
		name: '',
		form: PDFFormType.ON_GST_190_CALCULATION_WS,
		url: `2021/hst/${PDFFormType.ON_GST_190_CALCULATION_WS.toLowerCase()}.pdf`,
	},
	[PDFFormType.ON_GST_190_REBATE_SCHEDULE]: {
		type: PDFFormTypes.HST,
		name: '',
		form: PDFFormType.ON_GST_190_REBATE_SCHEDULE,
		url: `2021/hst/${PDFFormType.ON_GST_190_REBATE_SCHEDULE.toLowerCase()}.pdf`,
	},
	[PDFFormType.ON_GST_NEW_REBATE_RENTAL]: {
		type: PDFFormTypes.HST,
		name: '',
		form: PDFFormType.ON_GST_NEW_REBATE_RENTAL,
		url: `2021/hst/${PDFFormType.ON_GST_NEW_REBATE_RENTAL.toLowerCase()}.pdf`,
	},
	[PDFFormType.ON_GST_NEW_HOUSING_REBATE]: {
		type: PDFFormTypes.HST,
		name: '',
		form: PDFFormType.ON_GST_NEW_HOUSING_REBATE,
		url: `2021/hst/${PDFFormType.ON_GST_NEW_HOUSING_REBATE.toLowerCase()}.pdf`,
	},

	[PDFFormType.RBC_COLLATERAL_FINAL_REPORT]: {
		type: PDFFormTypes.RBC_COLLATERAL,
		name: 'Final report',
		form: PDFFormType.RBC_COLLATERAL_FINAL_REPORT,
		url: `2021/mortgage/rbc/${PDFFormType.RBC_COLLATERAL_FINAL_REPORT.toLowerCase()}.pdf`,
	},
	[PDFFormType.RBC_COLLATERAL_REQUEST_FOR_FUNDS]: {
		type: PDFFormTypes.RBC_COLLATERAL,
		name: 'Request for funds',
		form: PDFFormType.RBC_COLLATERAL_REQUEST_FOR_FUNDS,
		url: `2021/mortgage/rbc/${PDFFormType.RBC_COLLATERAL_REQUEST_FOR_FUNDS.toLowerCase()}.pdf`,
	},
	[PDFFormType.RBC_COLLATERAL_SCHEDULE_FIXED_RATE]: {
		type: PDFFormTypes.RBC_COLLATERAL,
		name: 'Schedule fixed rate',
		form: PDFFormType.RBC_COLLATERAL_SCHEDULE_FIXED_RATE,
		url: `2021/mortgage/rbc/${PDFFormType.RBC_COLLATERAL_SCHEDULE_FIXED_RATE.toLowerCase()}.pdf`,
	},
	[PDFFormType.RBC_COLLATERAL_SCHEDULE_PRIME_RATE]: {
		type: PDFFormTypes.RBC_COLLATERAL,
		name: 'Schedule prime rate',
		form: PDFFormType.RBC_COLLATERAL_SCHEDULE_PRIME_RATE,
		url: `2021/mortgage/rbc/${PDFFormType.RBC_COLLATERAL_SCHEDULE_PRIME_RATE.toLowerCase()}.pdf`,
	},
	[PDFFormType.RBC_COLLATERAL_STANDARD_CHARGE_TERMS]: {
		type: PDFFormTypes.RBC_COLLATERAL,
		name: 'Standard charge terms',
		form: PDFFormType.RBC_COLLATERAL_STANDARD_CHARGE_TERMS,
		url: `2021/mortgage/rbc/${PDFFormType.RBC_COLLATERAL_STANDARD_CHARGE_TERMS.toLowerCase()}.pdf`,
	},

	[PDFFormType.RBC_RESIDENTIAL_ASSIGNMENT_OF_SITE_LEASE]: {
		type: PDFFormTypes.RBC_RESIDENTIAL,
		name: 'Assignment of site lease',
		form: PDFFormType.RBC_RESIDENTIAL_ASSIGNMENT_OF_SITE_LEASE,
		url: `2021/mortgage/rbc/${PDFFormType.RBC_RESIDENTIAL_ASSIGNMENT_OF_SITE_LEASE.toLowerCase()}.pdf`,
	},
	[PDFFormType.RBC_RESIDENTIAL_FINAL_REPORT]: {
		type: PDFFormTypes.RBC_RESIDENTIAL,
		name: 'Final report',
		form: PDFFormType.RBC_RESIDENTIAL_FINAL_REPORT,
		url: `2021/mortgage/rbc/${PDFFormType.RBC_RESIDENTIAL_FINAL_REPORT.toLowerCase()}.pdf`,
	},
	[PDFFormType.RBC_RESIDENTIAL_LANDLORD_CONSENT]: {
		type: PDFFormTypes.RBC_RESIDENTIAL,
		name: 'Landlord consent',
		form: PDFFormType.RBC_RESIDENTIAL_LANDLORD_CONSENT,
		url: `2021/mortgage/rbc/${PDFFormType.RBC_RESIDENTIAL_LANDLORD_CONSENT.toLowerCase()}.pdf`,
	},
	[PDFFormType.RBC_RESIDENTIAL_LETTER_FOR_ILA]: {
		type: PDFFormTypes.RBC_RESIDENTIAL,
		name: 'Letter for ILA',
		form: PDFFormType.RBC_RESIDENTIAL_LETTER_FOR_ILA,
		url: `2021/mortgage/rbc/${PDFFormType.RBC_RESIDENTIAL_LETTER_FOR_ILA.toLowerCase()}.pdf`,
	},
	[PDFFormType.RBC_RESIDENTIAL_LETTER_OF_DIRECTION]: {
		type: PDFFormTypes.RBC_RESIDENTIAL,
		name: 'Letter of direction',
		form: PDFFormType.RBC_RESIDENTIAL_LETTER_OF_DIRECTION,
		url: `2021/mortgage/rbc/${PDFFormType.RBC_RESIDENTIAL_LETTER_OF_DIRECTION.toLowerCase()}.pdf`,
	},
	[PDFFormType.RBC_RESIDENTIAL_REQUEST_FOR_FUNDS]: {
		type: PDFFormTypes.RBC_RESIDENTIAL,
		name: 'Request for funds',
		form: PDFFormType.RBC_RESIDENTIAL_REQUEST_FOR_FUNDS,
		url: `2021/mortgage/rbc/${PDFFormType.RBC_RESIDENTIAL_REQUEST_FOR_FUNDS.toLowerCase()}.pdf`,
	},
	[PDFFormType.RBC_RESIDENTIAL_SECURITY_AGREEMENT]: {
		type: PDFFormTypes.RBC_RESIDENTIAL,
		name: 'Security agreement',
		form: PDFFormType.RBC_RESIDENTIAL_SECURITY_AGREEMENT,
		url: `2021/mortgage/rbc/${PDFFormType.RBC_RESIDENTIAL_SECURITY_AGREEMENT.toLowerCase()}.pdf`,
	},
	[PDFFormType.RBC_RESIDENTIAL_SCT_FIXED]: {
		type: PDFFormTypes.RBC_RESIDENTIAL,
		name: 'SCT fixed',
		form: PDFFormType.RBC_RESIDENTIAL_SCT_FIXED,
		url: `2021/mortgage/rbc/${PDFFormType.RBC_RESIDENTIAL_SCT_FIXED.toLowerCase()}.pdf`,
	},
	[PDFFormType.RBC_RESIDENTIAL_SCT_VARIABLE]: {
		type: PDFFormTypes.RBC_RESIDENTIAL,
		name: 'SCT variable',
		form: PDFFormType.RBC_RESIDENTIAL_SCT_VARIABLE,
		url: `2021/mortgage/rbc/${PDFFormType.RBC_RESIDENTIAL_SCT_VARIABLE.toLowerCase()}.pdf`,
	},

	[PDFFormType.BMO_COLLATERAL_FINAL_REPORT]: {
		type: PDFFormTypes.BMO_COLLATERAL,
		name: 'Final report',
		form: PDFFormType.BMO_COLLATERAL_FINAL_REPORT,
		url: `2021/mortgage/bmo/${PDFFormType.BMO_COLLATERAL_FINAL_REPORT.toLowerCase()}.pdf`,
	},
	[PDFFormType.BMO_COLLATERAL_REQUEST_FOR_FUNDS]: {
		type: PDFFormTypes.BMO_COLLATERAL,
		name: 'Request for funds',
		form: PDFFormType.BMO_COLLATERAL_REQUEST_FOR_FUNDS,
		url: `2021/mortgage/bmo/${PDFFormType.BMO_COLLATERAL_REQUEST_FOR_FUNDS.toLowerCase()}.pdf`,
	},
	[PDFFormType.BMO_COLLATERAL_SCHEDULE]: {
		type: PDFFormTypes.BMO_COLLATERAL,
		name: 'Schedule',
		form: PDFFormType.BMO_COLLATERAL_SCHEDULE,
		url: `2021/mortgage/bmo/${PDFFormType.BMO_COLLATERAL_SCHEDULE.toLowerCase()}.pdf`,
	},
	[PDFFormType.BMO_COLLATERAL_STANDARD_CHARGE_TERMS]: {
		type: PDFFormTypes.BMO_COLLATERAL,
		name: 'Standard charge terms',
		form: PDFFormType.BMO_COLLATERAL_STANDARD_CHARGE_TERMS,
		url: `2021/mortgage/bmo/${PDFFormType.BMO_COLLATERAL_STANDARD_CHARGE_TERMS.toLowerCase()}.pdf`,
	},

	[PDFFormType.BMO_CONVENTIONAL_ACKNOWLEDGEMENT_AND_DIRECTION]: {
		type: PDFFormTypes.BMO_CONVENTIONAL,
		name: 'Acknowledgement and direction',
		form: PDFFormType.BMO_CONVENTIONAL_ACKNOWLEDGEMENT_AND_DIRECTION,
		url: `2021/mortgage/bmo/${PDFFormType.BMO_CONVENTIONAL_ACKNOWLEDGEMENT_AND_DIRECTION.toLowerCase()}.pdf`,
	},
	[PDFFormType.BMO_CONVENTIONAL_COVER_SHEET]: {
		type: PDFFormTypes.BMO_CONVENTIONAL,
		name: 'Cover sheet',
		form: PDFFormType.BMO_CONVENTIONAL_COVER_SHEET,
		url: `2021/mortgage/bmo/${PDFFormType.BMO_CONVENTIONAL_COVER_SHEET.toLowerCase()}.pdf`,
	},
	[PDFFormType.BMO_CONVENTIONAL_FINAL_REPORT]: {
		type: PDFFormTypes.BMO_CONVENTIONAL,
		name: 'Final report',
		form: PDFFormType.BMO_CONVENTIONAL_FINAL_REPORT,
		url: `2021/mortgage/bmo/${PDFFormType.BMO_CONVENTIONAL_FINAL_REPORT.toLowerCase()}.pdf`,
	},
	[PDFFormType.BMO_CONVENTIONAL_ID_VERIFICATION]: {
		type: PDFFormTypes.BMO_CONVENTIONAL,
		name: 'ID verification',
		form: PDFFormType.BMO_CONVENTIONAL_ID_VERIFICATION,
		url: `2021/mortgage/bmo/${PDFFormType.BMO_CONVENTIONAL_ID_VERIFICATION.toLowerCase()}.pdf`,
	},
	[PDFFormType.BMO_CONVENTIONAL_MTG_DECLARATION_OF_POSSESSION]: {
		type: PDFFormTypes.BMO_CONVENTIONAL,
		name: 'MTG declaration of possession',
		form: PDFFormType.BMO_CONVENTIONAL_MTG_DECLARATION_OF_POSSESSION,
		url: `2021/mortgage/bmo/${PDFFormType.BMO_CONVENTIONAL_MTG_DECLARATION_OF_POSSESSION.toLowerCase()}.pdf`,
	},
	[PDFFormType.BMO_CONVENTIONAL_REQUEST_FOR_FUNDS]: {
		type: PDFFormTypes.BMO_CONVENTIONAL,
		name: 'Request for funds',
		form: PDFFormType.BMO_CONVENTIONAL_REQUEST_FOR_FUNDS,
		url: `2021/mortgage/bmo/${PDFFormType.BMO_CONVENTIONAL_REQUEST_FOR_FUNDS.toLowerCase()}.pdf`,
	},
	[PDFFormType.BMO_CONVENTIONAL_RESIDENTIAL_MORTGAGE_SCHEDULE]: {
		type: PDFFormTypes.BMO_CONVENTIONAL,
		name: 'Residential mortgage schedule',
		form: PDFFormType.BMO_CONVENTIONAL_RESIDENTIAL_MORTGAGE_SCHEDULE,
		url: `2021/mortgage/bmo/${PDFFormType.BMO_CONVENTIONAL_RESIDENTIAL_MORTGAGE_SCHEDULE.toLowerCase()}.pdf`,
	},

	[PDFFormType.HOME_TRUST_ACKNOWLEDGEMENT_AND_DIRECTION_REFUNDS]: {
		type: PDFFormTypes.HOME_TRUST,
		name: 'Acknowledgement and direction refunds',
		form: PDFFormType.HOME_TRUST_ACKNOWLEDGEMENT_AND_DIRECTION_REFUNDS,
		url: `2021/mortgage/home_trust/${PDFFormType.HOME_TRUST_ACKNOWLEDGEMENT_AND_DIRECTION_REFUNDS.toLowerCase()}.pdf`,
	},
	[PDFFormType.HOME_TRUST_AUTHORIZATION_DIRECTION_AND_CONSENT]: {
		type: PDFFormTypes.HOME_TRUST,
		name: 'Authorization direction and consent',
		form: PDFFormType.HOME_TRUST_AUTHORIZATION_DIRECTION_AND_CONSENT,
		url: `2021/mortgage/home_trust/${PDFFormType.HOME_TRUST_AUTHORIZATION_DIRECTION_AND_CONSENT.toLowerCase()}.pdf`,
	},
	[PDFFormType.HOME_TRUST_FINAL_REPORT]: {
		type: PDFFormTypes.HOME_TRUST,
		name: 'Final report',
		form: PDFFormType.HOME_TRUST_FINAL_REPORT,
		url: `2021/mortgage/home_trust/${PDFFormType.HOME_TRUST_FINAL_REPORT.toLowerCase()}.pdf`,
	},
	[PDFFormType.HOME_TRUST_PAYMENT_CHANGE_REQUEST_FORM]: {
		type: PDFFormTypes.HOME_TRUST,
		name: 'Payment change request form',
		form: PDFFormType.HOME_TRUST_PAYMENT_CHANGE_REQUEST_FORM,
		url: `2021/mortgage/home_trust/${PDFFormType.HOME_TRUST_PAYMENT_CHANGE_REQUEST_FORM.toLowerCase()}.pdf`,
	},
	[PDFFormType.HOME_TRUST_PREAUTHORIZED_DEBIT_AGREEMENT]: {
		type: PDFFormTypes.HOME_TRUST,
		name: 'Preauthorized debit agreement',
		form: PDFFormType.HOME_TRUST_PREAUTHORIZED_DEBIT_AGREEMENT,
		url: `2021/mortgage/home_trust/${PDFFormType.HOME_TRUST_PREAUTHORIZED_DEBIT_AGREEMENT.toLowerCase()}.pdf`,
	},
	[PDFFormType.HOME_TRUST_REQUEST_FOR_FUNDS]: {
		type: PDFFormTypes.HOME_TRUST,
		name: 'Request for funds',
		form: PDFFormType.HOME_TRUST_REQUEST_FOR_FUNDS,
		url: `2021/mortgage/home_trust/${PDFFormType.HOME_TRUST_REQUEST_FOR_FUNDS.toLowerCase()}.pdf`,
	},
	[PDFFormType.HOME_TRUST_SOLICITOR_DECLARATION_REIDENTIFICATION]: {
		type: PDFFormTypes.HOME_TRUST,
		name: 'Solicitor declaration reidentification',
		form: PDFFormType.HOME_TRUST_SOLICITOR_DECLARATION_REIDENTIFICATION,
		url: `2021/mortgage/home_trust/${PDFFormType.HOME_TRUST_SOLICITOR_DECLARATION_REIDENTIFICATION.toLowerCase()}.pdf`,
	},
	[PDFFormType.HOME_TRUST_STANDARD_CHARGE_TERMS]: {
		type: PDFFormTypes.HOME_TRUST,
		name: 'Standard charge terms',
		form: PDFFormType.HOME_TRUST_STANDARD_CHARGE_TERMS,
		url: `2021/mortgage/home_trust/${PDFFormType.HOME_TRUST_STANDARD_CHARGE_TERMS.toLowerCase()}.pdf`,
	},
	[PDFFormType.HOME_TRUST_STATUTORY_DECLARATION]: {
		type: PDFFormTypes.HOME_TRUST,
		name: 'Statutory declaration',
		form: PDFFormType.HOME_TRUST_STATUTORY_DECLARATION,
		url: `2021/mortgage/home_trust/${PDFFormType.HOME_TRUST_STATUTORY_DECLARATION.toLowerCase()}.pdf`,
	},
	[PDFFormType.HOME_TRUST_TENANT_ACKNOWLEDGEMENT]: {
		type: PDFFormTypes.HOME_TRUST,
		name: 'Tenant acknowledgement',
		form: PDFFormType.HOME_TRUST_TENANT_ACKNOWLEDGEMENT,
		url: `2021/mortgage/home_trust/${PDFFormType.HOME_TRUST_TENANT_ACKNOWLEDGEMENT.toLowerCase()}.pdf`,
	},

	[PDFFormType.FIRST_NATIONAL_REQUEST_FOR_FUNDS]: {
		type: PDFFormTypes.FIRST_NATIONAL,
		name: 'Request for funds',
		form: PDFFormType.FIRST_NATIONAL_REQUEST_FOR_FUNDS,
		url: `2021/mortgage/first_national/${PDFFormType.FIRST_NATIONAL_REQUEST_FOR_FUNDS.toLowerCase()}.pdf`,
	},
	[PDFFormType.FIRST_NATIONAL_REPORT_ON_TITLE]: {
		type: PDFFormTypes.FIRST_NATIONAL,
		name: 'Final report',
		form: PDFFormType.FIRST_NATIONAL_REPORT_ON_TITLE,
		url: `2021/mortgage/first_national/${PDFFormType.FIRST_NATIONAL_REPORT_ON_TITLE.toLowerCase()}.pdf`,
	},

	[PDFFormType.TD_REQUEST_FOR_FUNDS]: {
		type: PDFFormTypes.TD,
		name: 'Request for funds',
		form: PDFFormType.TD_REQUEST_FOR_FUNDS,
		url: `2021/mortgage/td/${PDFFormType.TD_REQUEST_FOR_FUNDS.toLowerCase()}.pdf`,
	},
	[PDFFormType.TD_FINAL_REPORT]: {
		type: PDFFormTypes.TD,
		name: 'Final report',
		form: PDFFormType.TD_FINAL_REPORT,
		url: `2021/mortgage/td/${PDFFormType.TD_FINAL_REPORT.toLowerCase()}.pdf`,
	},
	[PDFFormType.TD_FACE_TO_FACE_ID]: {
		type: PDFFormTypes.TD,
		name: 'Face to face id',
		form: PDFFormType.TD_FACE_TO_FACE_ID,
		url: `2021/mortgage/td/${PDFFormType.TD_FACE_TO_FACE_ID.toLowerCase()}.pdf`,
	},
	[PDFFormType.TD_PRIVACY_AGREEMENT]: {
		type: PDFFormTypes.TD,
		name: 'Privacy agreement',
		form: PDFFormType.TD_PRIVACY_AGREEMENT,
		url: `2021/mortgage/td/${PDFFormType.TD_PRIVACY_AGREEMENT.toLowerCase()}.pdf`,
	},
	[PDFFormType.TD_NON_FACE_TO_FACE_ID]: {
		type: PDFFormTypes.TD,
		name: 'Non face to face id',
		form: PDFFormType.TD_NON_FACE_TO_FACE_ID,
		url: `2021/mortgage/td/${PDFFormType.TD_NON_FACE_TO_FACE_ID.toLowerCase()}.pdf`,
	},
	[PDFFormType.TD_SCHEDULE_1]: {
		type: PDFFormTypes.TD,
		name: 'Schedule 1',
		form: PDFFormType.TD_SCHEDULE_1,
		url: `2021/mortgage/td/${PDFFormType.TD_SCHEDULE_1.toLowerCase()}.pdf`,
	},

	[PDFFormType.CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_FINAL_REPORT]: {
		type: PDFFormTypes.CIBC_DOCUMENTS_COLLATERAL_MORTGAGE,
		name: 'Final report',
		form: PDFFormType.CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_FINAL_REPORT,
		url: `2021/mortgage/cibc/documents/${PDFFormType.CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_FINAL_REPORT.toLowerCase()}.pdf`,
	},
	[PDFFormType.CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_NOTIFICATION_OF_REGISTRATION]:
		{
			type: PDFFormTypes.CIBC_DOCUMENTS_COLLATERAL_MORTGAGE,
			name: 'Notification of registration',
			form: PDFFormType.CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_NOTIFICATION_OF_REGISTRATION,
			url: `2021/mortgage/cibc/documents/${PDFFormType.CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_NOTIFICATION_OF_REGISTRATION.toLowerCase()}.pdf`,
		},
	[PDFFormType.CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS]: {
		type: PDFFormTypes.CIBC_DOCUMENTS_COLLATERAL_MORTGAGE,
		name: 'Request for funds',
		form: PDFFormType.CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS,
		url: `2021/mortgage/cibc/documents/${PDFFormType.CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS.toLowerCase()}.pdf`,
	},

	[PDFFormType.CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_FINAL_REPORT]: {
		type: PDFFormTypes.CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE,
		name: 'Final report',
		form: PDFFormType.CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_FINAL_REPORT,
		url: `2021/mortgage/cibc/documents/${PDFFormType.CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_FINAL_REPORT.toLowerCase()}.pdf`,
	},
	[PDFFormType.CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS]:
		{
			type: PDFFormTypes.CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE,
			name: 'Request for funds',
			form: PDFFormType.CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS,
			url: `2021/mortgage/cibc/documents/${PDFFormType.CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS.toLowerCase()}.pdf`,
		},

	[PDFFormType.CIBC_DOCUMENTS_HOME_POWER_PLAN_FINAL_REPORT]: {
		type: PDFFormTypes.CIBC_DOCUMENTS_HOME_POWER_PLAN,
		name: 'Final report',
		form: PDFFormType.CIBC_DOCUMENTS_HOME_POWER_PLAN_FINAL_REPORT,
		url: `2021/mortgage/cibc/documents/${PDFFormType.CIBC_DOCUMENTS_HOME_POWER_PLAN_FINAL_REPORT.toLowerCase()}.pdf`,
	},
	[PDFFormType.CIBC_DOCUMENTS_HOME_POWER_PLAN_ID_VERIFICATION]: {
		type: PDFFormTypes.CIBC_DOCUMENTS_HOME_POWER_PLAN,
		name: 'ID verification',
		form: PDFFormType.CIBC_DOCUMENTS_HOME_POWER_PLAN_ID_VERIFICATION,
		url: `2021/mortgage/cibc/documents/${PDFFormType.CIBC_DOCUMENTS_HOME_POWER_PLAN_ID_VERIFICATION.toLowerCase()}.pdf`,
	},
	[PDFFormType.CIBC_DOCUMENTS_HOME_POWER_PLAN_REQUEST_FOR_FUNDS]: {
		type: PDFFormTypes.CIBC_DOCUMENTS_HOME_POWER_PLAN,
		name: 'Request for funds',
		form: PDFFormType.CIBC_DOCUMENTS_HOME_POWER_PLAN_REQUEST_FOR_FUNDS,
		url: `2021/mortgage/cibc/documents/${PDFFormType.CIBC_DOCUMENTS_HOME_POWER_PLAN_REQUEST_FOR_FUNDS.toLowerCase()}.pdf`,
	},
	[PDFFormType.CIBC_DOCUMENTS_HOME_POWER_PLAN_STANDARD_CHARGE_TERMS]: {
		type: PDFFormTypes.CIBC_DOCUMENTS_HOME_POWER_PLAN,
		name: 'Standard charge terms',
		form: PDFFormType.CIBC_DOCUMENTS_HOME_POWER_PLAN_STANDARD_CHARGE_TERMS,
		url: `2021/mortgage/cibc/documents/${PDFFormType.CIBC_DOCUMENTS_HOME_POWER_PLAN_STANDARD_CHARGE_TERMS.toLowerCase()}.pdf`,
	},

	[PDFFormType.CIBC_DOCUMENTS_MORTGAGE_FINAL_REPORT]: {
		type: PDFFormTypes.CIBC_DOCUMENTS_MORTGAGE,
		name: 'Final report',
		form: PDFFormType.CIBC_DOCUMENTS_MORTGAGE_FINAL_REPORT,
		url: `2021/mortgage/cibc/documents/${PDFFormType.CIBC_DOCUMENTS_MORTGAGE_FINAL_REPORT.toLowerCase()}.pdf`,
	},
	[PDFFormType.CIBC_DOCUMENTS_MORTGAGE_ID_VERIFICATION]: {
		type: PDFFormTypes.CIBC_DOCUMENTS_MORTGAGE,
		name: 'ID verification',
		form: PDFFormType.CIBC_DOCUMENTS_MORTGAGE_ID_VERIFICATION,
		url: `2021/mortgage/cibc/documents/${PDFFormType.CIBC_DOCUMENTS_MORTGAGE_ID_VERIFICATION.toLowerCase()}.pdf`,
	},
	[PDFFormType.CIBC_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS]: {
		type: PDFFormTypes.CIBC_DOCUMENTS_MORTGAGE,
		name: 'Request for funds',
		form: PDFFormType.CIBC_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS,
		url: `2021/mortgage/cibc/documents/${PDFFormType.CIBC_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS.toLowerCase()}.pdf`,
	},
	[PDFFormType.CIBC_DOCUMENTS_MORTGAGE_STANDARD_CHARGE_TERMS]: {
		type: PDFFormTypes.CIBC_DOCUMENTS_MORTGAGE,
		name: 'Standard charge terms',
		form: PDFFormType.CIBC_DOCUMENTS_MORTGAGE_STANDARD_CHARGE_TERMS,
		url: `2021/mortgage/cibc/documents/${PDFFormType.CIBC_DOCUMENTS_MORTGAGE_STANDARD_CHARGE_TERMS.toLowerCase()}.pdf`,
	},

	[PDFFormType.CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_FINAL_REPORT]: {
		type: PDFFormTypes.CIBC_DOCUMENTS_SPLC_FOR_PURCHASE,
		name: 'Final report',
		form: PDFFormType.CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_FINAL_REPORT,
		url: `2021/mortgage/cibc/documents/${PDFFormType.CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_FINAL_REPORT.toLowerCase()}.pdf`,
	},
	[PDFFormType.CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_REQUEST_FOR_FUNDS]: {
		type: PDFFormTypes.CIBC_DOCUMENTS_SPLC_FOR_PURCHASE,
		name: 'Request for funds',
		form: PDFFormType.CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_REQUEST_FOR_FUNDS,
		url: `2021/mortgage/cibc/documents/${PDFFormType.CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_REQUEST_FOR_FUNDS.toLowerCase()}.pdf`,
	},

	[PDFFormType.CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_FINAL_REPORT]: {
		type: PDFFormTypes.CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE,
		name: 'Final report',
		form: PDFFormType.CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_FINAL_REPORT,
		url: `2021/mortgage/cibc/simplii_financial_documents/${PDFFormType.CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_FINAL_REPORT.toLowerCase()}.pdf`,
	},
	[PDFFormType.CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS]: {
		type: PDFFormTypes.CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE,
		name: 'Request for funds',
		form: PDFFormType.CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS,
		url: `2021/mortgage/cibc/simplii_financial_documents/${PDFFormType.CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS.toLowerCase()}.pdf`,
	},
	[PDFFormType.CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_STANDARD_CHARGE_TERMS]:
		{
			type: PDFFormTypes.CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE,
			name: 'Standard charge terms',
			form: PDFFormType.CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_STANDARD_CHARGE_TERMS,
			url: `2021/mortgage/cibc/simplii_financial_documents/${PDFFormType.CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_STANDARD_CHARGE_TERMS.toLowerCase()}.pdf`,
		},

	[PDFFormType.CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_FINAL_REPORT]:
		{
			type: PDFFormTypes.CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT,
			name: 'Final report',
			form: PDFFormType.CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_FINAL_REPORT,
			url: `2021/mortgage/cibc/simplii_financial_documents/${PDFFormType.CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_FINAL_REPORT.toLowerCase()}.pdf`,
		},
	[PDFFormType.CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_REQUEST_FOR_FUNDS]:
		{
			type: PDFFormTypes.CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT,
			name: 'Request for funds',
			form: PDFFormType.CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_REQUEST_FOR_FUNDS,
			url: `2021/mortgage/cibc/simplii_financial_documents/${PDFFormType.CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_REQUEST_FOR_FUNDS.toLowerCase()}.pdf`,
		},

	[PDFFormType.STANDALONE_PURCHASE_PRESCRIBED_INFORMATION_FORM]: {
		type: PDFFormTypes.STANDALONE_PURCHASE,
		name: 'Prescribed information',
		form: PDFFormType.STANDALONE_PURCHASE_PRESCRIBED_INFORMATION_FORM,
		url: `2021/mortgage/standalone/${PDFFormType.STANDALONE_PURCHASE_PRESCRIBED_INFORMATION_FORM.toLowerCase()}.pdf`,
	},

	[PDFFormType.LTT_AFFIDAVIT_FORM]: {
		type: PDFFormTypes.LTT,
		name: 'LTT Affidavit form',
		form: PDFFormType.LTT_AFFIDAVIT_FORM,
		url: `2022/ltt/${PDFFormType.LTT_AFFIDAVIT_FORM.toLowerCase()}.pdf`,
	},

	[PDFFormType.LTT_REBATE_FORM]: {
		type: PDFFormTypes.LTT,
		name: 'LTT Rebate form',
		form: PDFFormType.LTT_REBATE_FORM,
		url: `2022/ltt/${PDFFormType.LTT_REBATE_FORM.toLowerCase()}.pdf`,
	},

	[PDFFormType.MLTT_REBATE_FORM]: {
		type: PDFFormTypes.LTT,
		name: 'MLTT Rebate form',
		form: PDFFormType.MLTT_REBATE_FORM,
		url: `2022/mltt/${PDFFormType.MLTT_REBATE_FORM.toLowerCase()}.pdf`,
	},

	[PDFFormType.MLTT_AFFIDAVIT_FORM]: {
		type: PDFFormTypes.MLTT,
		name: 'MLTT Affidavit form',
		form: PDFFormType.MLTT_AFFIDAVIT_FORM,
		url: `2022/mltt/${PDFFormType.MLTT_AFFIDAVIT_FORM.toLowerCase()}.pdf`,
	},

	[PDFFormType.MLTT_SUPPLEMENTARY_FORM]: {
		type: PDFFormTypes.MLTT,
		name: 'MLTT Affidavit form',
		form: PDFFormType.MLTT_SUPPLEMENTARY_FORM,
		url: `2022/mltt/${PDFFormType.MLTT_SUPPLEMENTARY_FORM.toLowerCase()}.pdf`,
	},

	[PDFFormType.FCT_UNDER_25]: {
		type: PDFFormTypes.FCT,
		name: 'FCT Under 25',
		form: PDFFormType.FCT_UNDER_25,
		url: `2022/commercial-title-insurance/fct/${PDFFormType.FCT_UNDER_25.toLowerCase()}.pdf`,
	},
	[PDFFormType.FCT_OVER_25]: {
		type: PDFFormTypes.FCT,
		name: 'FCT Over 25',
		form: PDFFormType.FCT_OVER_25,
		url: `2022/commercial-title-insurance/fct/${PDFFormType.FCT_OVER_25.toLowerCase()}.pdf`,
	},
};
